import { c as _c } from "react/compiler-runtime";
import { MdGavel } from "react-icons/md";
import { chargebackTierLabels, chargebackTierVariants } from "@/app/[tenant]/(console)/billing/chargebacks/constants";
import { Badge, Tooltip } from "@/components/ui";
import { formatDateTime } from "@/lib/format-data";
import type { ChargebackTier } from "@/types/chargeback";
interface ChargebackBadgeProps {
  tier: ChargebackTier | null | undefined;
  dueDate?: string | null;
  count?: number;
  className?: string;
}
export default function ChargebackBadge(t0) {
  const $ = _c(25);
  const {
    tier,
    dueDate,
    count,
    className
  } = t0;
  if (!tier) {
    return null;
  }
  const label = chargebackTierLabels[tier];
  const variant = chargebackTierVariants[tier];
  const showDeadline = tier === "ACTION_REQUIRED" && dueDate;
  const t1 = count && count > 1 ? `${count} chargebacks linked` : null;
  let t2;
  if ($[0] !== dueDate || $[1] !== showDeadline) {
    t2 = showDeadline ? `Respond by ${formatDateTime(dueDate)}` : null;
    $[0] = dueDate;
    $[1] = showDeadline;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label || $[4] !== t1 || $[5] !== t2) {
    t3 = [label, t1, t2].filter(Boolean);
    $[3] = label;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const tooltipParts = t3;
  const t4 = tooltipParts.join(" \u2014 ");
  const t5 = count && count > 1 ? ` (${count})` : null;
  let t6;
  if ($[7] !== t5) {
    t6 = <span>{t5}</span>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== dueDate || $[10] !== showDeadline) {
    t7 = showDeadline ? ` · due ${formatDateTime(dueDate)}` : null;
    $[9] = dueDate;
    $[10] = showDeadline;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <span>{t7}</span>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== label || $[15] !== t6 || $[16] !== t8) {
    t9 = <span>{label}{t6}{t8}</span>;
    $[14] = label;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== className || $[19] !== t9 || $[20] !== variant) {
    t10 = <Badge variant={variant} icon={MdGavel} className={className}>{t9}</Badge>;
    $[18] = className;
    $[19] = t9;
    $[20] = variant;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t4) {
    t11 = <Tooltip content={t4}>{t10}</Tooltip>;
    $[22] = t10;
    $[23] = t4;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}